import React from 'react';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  const handleSelectPlan = (plan) => {
   navigate(`/checkout?plan=${plan}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Choose Your Plan</h1>
          <p className="text-xl text-gray-600">No hidden fees. Cancel anytime. 14-day free trial on all plans.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Starter Plan */}
          <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 hover:shadow-xl transition">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Starter</h3>
            <div className="text-4xl font-bold text-blue-600 mb-6">
              $29<span className="text-lg text-gray-600">/month</span>
            </div>
            <p className="text-sm text-gray-500 mb-6">14-day free trial included</p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Up to 3 devices</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Basic threat detection</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Weekly reports</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Email support</span>
              </li>
            </ul>
            <button
              onClick={() => handleSelectPlan('starter')}
              className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              Start Free Trial
            </button>
          </div>

          {/* Business Plan */}
          <div className="bg-blue-600 p-8 rounded-lg shadow-xl border-4 border-blue-700 transform scale-105">
            <div className="bg-yellow-400 text-blue-900 text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
              MOST POPULAR
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Business</h3>
            <div className="text-4xl font-bold text-white mb-6">
              $49<span className="text-lg text-blue-200">/month</span>
            </div>
            <p className="text-sm text-blue-100 mb-6">14-day free trial included</p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Up to 10 users</span>
              </li>
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Advanced threat detection</span>
              </li>
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Real-time alerts</span>
              </li>
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Two-factor authentication</span>
              </li>
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Priority support</span>
              </li>
              <li className="flex items-start">
                <span className="text-white mr-2">✓</span>
                <span className="text-white">Compliance reports</span>
              </li>
            </ul>
            <button
              onClick={() => handleSelectPlan('business')}
              className="block w-full text-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
            >
              Start Free Trial
            </button>
          </div>

          {/* Enterprise Plan */}
          <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 hover:shadow-xl transition">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Enterprise</h3>
            <div className="text-4xl font-bold text-blue-600 mb-6">
              $149<span className="text-lg text-gray-600">/month</span>
            </div>
            <p className="text-sm text-gray-500 mb-6">14-day free trial included</p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Unlimited users</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Custom integrations</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Dedicated account manager</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">API access</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">White-label option</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">24/7 phone support</span>
              </li>
            </ul>
            <button
              onClick={() => handleSelectPlan('enterprise')}
              className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              Start Free Trial
            </button>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-20 max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-bold text-gray-900 mb-2">When will I be charged?</h3>
              <p className="text-gray-700">You won't be charged for 14 days. Your card will only be charged after your free trial ends unless you cancel before then.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-bold text-gray-900 mb-2">Can I cancel anytime?</h3>
              <p className="text-gray-700">Yes! You can cancel your subscription at any time from your account settings. No questions asked.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="font-bold text-gray-900 mb-2">Can I upgrade or downgrade my plan?</h3>
              <p className="text-gray-700">Absolutely! You can change your plan at any time from your account dashboard. Changes are prorated automatically.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;